import { Box, Checkbox, colors, FormControlLabel, Grid2 as Grid, Typography } from "@mui/material"
import FontAwesomeIcon from "@v2/components/FontAwesomeIcon"
import FlexBox from "@v2/components/styled/FlexBox"
import { uiColors } from "@v2/lib/color"
import { useCallback, useImperativeHandle, useState } from "react"
import { FilterBaseProps, OptimumColorType } from "../../types"


export type ColorFilterValueType = null | string[]
export interface ColorFilterProps extends FilterBaseProps<ColorFilterValueType> {
    options: OptimumColorType[],
}

export default function ColorFilter({ ref, options, defaultValue, searchParamsKey }: ColorFilterProps) {

    const [value, setValue] = useState<ColorFilterValueType>(defaultValue ?? [])

    useImperativeHandle(ref, () => ({
        extract: () => {
            return value?.length ? value : null
        },
        apply: (params: URLSearchParams): URLSearchParams => {
            if (value?.length) {
                params.set(searchParamsKey, value.join(','))
            } else {
                params.delete(searchParamsKey)
            }
            return params;
        },
        clear: () => setValue(null)
    }), [value])

    const onSelectItem = useCallback((option) => () => {
        const optionValue = String(option.id)
        const isExists = value?.indexOf(optionValue) > -1;
        setValue(v => isExists
            ? v.filter(i => i !== optionValue)
            : [...(v ?? []), optionValue])
    }, [value])
    return (
        <Box dir="ltr" sx={{
            mt: options.length > 10 ? 2 : 0
        }}>
            <Box sx={{
                maxHeight: 5 * 38,
                overflowY: 'auto',
                scrollbarColor: `${colors.grey[800]} ${colors.grey[200]}`,
                scrollbarWidth: 'thin',
                scrollBehavior: 'smooth',
                pl: 2
            }}>
                <Grid dir="rtl" container spacing={0} pb={1}>
                    {options?.map((color, index) => {
                        const isSelected = value?.indexOf(String(color.id)) > -1
                        return (
                            <Grid size={{ xs: 12, xs2: 6 }} key={index}>
                                <FormControlLabel sx={{
                                    userSelect: 'none',
                                }} onChange={onSelectItem(color)}
                                    control={<Checkbox disableRipple name="color" checked={isSelected} icon={
                                        <FontAwesomeIcon size={22} color={colors.grey[700]} icon="fa-light fa-square" />
                                    } checkedIcon={
                                        <FontAwesomeIcon size={22} color={uiColors.primary} icon="fa-light fa-solid fa-square-check" />
                                    } />} label={
                                        <FlexBox>
                                            <Box key={color.id} component="span" sx={{
                                                height: 20,
                                                width: 20,
                                                minWidth: 20,
                                                borderRadius: '50%',
                                                border: '2px solid #fff',
                                                display: 'inline-block',
                                                position: 'relative',
                                                bgcolor: color.code ?? '#808080',
                                                backgroundImage: color.texture ? `url('${process.env.NEXT_PUBLIC_BASE_API_URL}/api/v1/media/${color.texture}?height=38')` : undefined,
                                                backgroundSize: 'cover'
                                            }} />
                                            <Typography component="span" sx={{
                                                ml: 1,
                                                fontSize: { xs: 13, sm: 16 }

                                            }}>{color.title}</Typography>
                                        </FlexBox>
                                    } />
                            </Grid>
                        )
                    })}
                </Grid>
            </Box>
        </Box>

    )
}